module.exports = __webpack_public_path__ + "static/media/authentication.92e89ec5.svg";